import React, {Component, Fragment} from 'react';
import autobind from 'autobind-decorator';
import {Line} from 'rc-progress';

class InflowProcessBar extends Component {

  static getDerivedStateFromProps(props, state) {

    if (state === null || props.data !== state.data) {
      const useRefLayer = props.hasOwnProperty('useRefLayer') ? props.useRefLayer : false;
      const {data, lineColor} = props;
      return {
        data: data,
        lineColor: lineColor,
        useRefLayer: useRefLayer,
      }
    }
    return null;
  }

  constructor(props) {
    super(props);
  }

  @autobind
  changeShowInflowLayer(isLayerOpen) {
    this.setState({isLayerOpen: isLayerOpen});
  }

  render() {
    const {data, lineColor} = this.state;
    const {list, totalNumberFormat, label, percentage} = data;

    return (
      <Fragment>
        <div className="detail_data">
          <dl className="list_statistic">
            <dt className="tit_statistic_type1"><strong>{label}</strong></dt>
            <dd className="txt_data">{totalNumberFormat}</dd>
          </dl>
          <Line className="bar_data"
                percent={percentage}
                strokeColor={lineColor}
                strokeWidth="1.3"
                trailColor="#eeeeee"
                strokeLinecap="round"/>

          {list.map((item, index) => <InflowItem key={index} label={item.label} countNumberFormat={item.countNumberFormat}/>)}

          {this.props.children}

        </div>
      </Fragment>
    );
  }
}

function InflowItem(props) {
  const {label, countNumberFormat} = props;
  return <dl className="list_statistic">
    <dt className="tit_statistic_type1">{label}</dt>
    <dd className="txt_data">{countNumberFormat}</dd>
  </dl>
}

export default InflowProcessBar;
